// Tab order of the Co-living page. Each entry is added when its page
// is built; the base `co_living` route redirects to the first one.
export const TABS = [
  { key: 'condos', route: 'co_living_condos' },
  { key: 'residents', route: 'co_living_residents' },
  { key: 'categories', route: 'co_living_categories' },
  { key: 'roles', route: 'co_living_roles' },
  { key: 'team', route: 'co_living_team' },
  { key: 'routing', route: 'co_living_routing' },
  { key: 'sla', route: 'co_living_sla' },
  { key: 'calendar', route: 'co_living_calendar' },
];

// One class string for every <input>, <select> and <textarea> in this module.
//
// _base.scss styles bare form tags globally, and its input rule
// (`input[type=text|number|password|date|email|url]:not(.reset-base)`,
// specificity 0,2,1) beats any single utility class, so py-2/px-3/rounded-lg
// and the margin never applied on those inputs. `reset-base` opts out of that
// rule; the rest of the string then supplies every property the rule used to
// (height, size, margin, disabled look), so inputs, selects and textareas
// match. Keep `reset-base` in here: the spec in constants.spec.js and the
// template scan in fieldClassUsage.spec.js fail if it or the class goes missing.
export const FIELD_CLASS =
  'reset-base block box-border mb-0 text-base font-normal [&:not(textarea)]:h-10 bg-white dark:bg-slate-700 border border-slate-300 dark:border-slate-600 rounded-lg py-2 px-3 w-full focus:outline-none focus:ring-2 focus:ring-woot-500 focus:border-transparent transition-all text-slate-900 dark:text-slate-100 disabled:bg-slate-100 dark:disabled:bg-slate-800 disabled:text-slate-400 disabled:cursor-not-allowed';

// A <select> also draws its arrow as a background image (global `select {}`
// rule), so it needs the wider right padding.
export const SELECT_CLASS = `${FIELD_CLASS} pr-8`;

export const CARD_CLASS =
  'bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-lg p-6';
